export default __webpack_public_path__ + "static/Room-B-858ec4af4eb215193c04877542009e6d.jpg";